import React, { Component } from 'react'
import FontAwesome from 'react-fontawesome'
import moment from 'moment'
import { get, orderBy } from 'lodash'
import { Table } from 'react-bootstrap'

import PropertyTitle from './PropertyTitle'
import DisplayLabel from '../components/DisplayLabel'

export default class LicenseTable extends Component {

  render() {
    const { history, showGroups } = this.props
    let licenses = orderBy(this.props.licenses, ['startDate', 'product.name'], 'desc')

    return <div>
        <PropertyTitle small icon='key' text='Licenties' />
        <div className='tablescontainer'>
          { licenses.length > 0 ? <Table striped>
              <thead>
                <tr>
                  <th>Product</th>
                  <th>Start- en einddatum</th>
                  { showGroups && <th>Groep</th> }
                  <th>Aantal notities</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                { licenses && licenses.map((license, index) =>
                  <tr 
                    className='license' 
                    key={index} 
                    onClick={() => history.push(`/licenties/${license.id}`)}
                  >
                    <td>
                      <FontAwesome 
                        name='cube' 
                        size='lg' 
                      /> { get(license, 'product.name') }
                    </td>
                    <td>
                      <FontAwesome 
                        name='clock-o' 
                        size='lg' 
                      />
                      <span> { license.startDate ? moment(get(license, 'startDate'), 'YYYY-MM-DD').format('DD-MM-YYYY') : '-' } { license.endDate && <span> - {moment(get(license, 'endDate'), 'YYYY-MM-DD').format('DD-MM-YYYY')} </span>}</span></td>
                    { showGroups && <td>{license.group && <span><FontAwesome name='users' size='lg' /> {license.group.name}</span>}</td> }
                    <td>
                      <FontAwesome name='comment-o'/> { !license.notes ? 0 : license.notes.length }
                    </td>
                    <td>{license.status} 
                      <span className='status'> <DisplayLabel type='STATUS' value={license} />
                      </span> 
                    </td>
                  </tr>
                )}
              </tbody>
            </Table> : <p>Geen licenties</p> }
        </div>
      </div>
  }
}
